import React from "react";
import styles from "./Advantages.module.css";

const Advantages = () => {
  const advantages = [
    "Low Cost & High Return Business",
    "24*7 Brand Support",
    "Established brand",
    "We believe in 100% transparency",
    "Unlimited Growth Opportunity",
    "Quick ROI",
    "Staff Training and support by Brand",
    "Help in Marketing",
  ];

  return (
    <section className={styles.advantages}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">Advantages of STEMx Channel Partner</h2>
        <div className={styles.grid}>
          {advantages.map((advantage, index) => (
            <div
              key={index}
              className={styles.advantage}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className={styles.icon}>✓</div>
              <p>{advantage}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
